import { setCategories } from '../../actions';
import { identityPayload, createReducer, forAction } from '../../utils';

const initialState = [];

export default createReducer(
  [forAction(setCategories, identityPayload)],
  initialState,
);
